import { useEffect, useMemo } from 'react';
import {
  dispatch,
  getQueryThread,
  getWorkspaceId,
  updateChannel,
  useAppSelector,
  useLazyGetChannelDetailsQuery,
} from '@zonofi/zono-money-store';

const MAX_VISIBLE = 2;
export const useGetQueryChannelDetails = () => {
  const queryThread = useAppSelector(getQueryThread);
  const sellerWorkspaceId = useAppSelector(getWorkspaceId);
  const [channelDetailsApi, channelDetailsResponse] =
    useLazyGetChannelDetailsQuery();

  useEffect(() => {
    if (queryThread?.channelId) {
      channelDetailsApi({
        workspaceId: sellerWorkspaceId,
        sellerWorkspaceId: sellerWorkspaceId,
        channelId: queryThread?.channelId,
      })
        .unwrap()
        .then((res) => {
          dispatch(updateChannel(res));
        });
    }
  }, [queryThread?.channelId]);

  const customerNames = useMemo(
    () =>
      (channelDetailsResponse?.data?.customers ?? [])
        .map((c: any) => c.name)
        .filter(Boolean),
    [channelDetailsResponse?.data?.customers]
  );

  const teamMemberNames = useMemo(
    () =>
      (channelDetailsResponse?.data?.teamMembers ?? [])
        .map((m: any) => m.employeeName)
        .filter(Boolean),
    [channelDetailsResponse?.data?.teamMembers]
  );

  const allNames = useMemo(
    () => [...customerNames, ...teamMemberNames],
    [customerNames, teamMemberNames]
  );

  const subtitle = useMemo(() => {
    if (allNames.length === 0) return '';
    if (allNames.length <= MAX_VISIBLE) return allNames.join(', ');
    return `${allNames.slice(0, MAX_VISIBLE).join(', ')}, ..+${allNames.length - MAX_VISIBLE}`;
  }, [allNames]);

  const customerId = useMemo(() => {
    return channelDetailsResponse?.data?.customerId;
  }, [channelDetailsResponse?.data?.customerId]);

  return {
    subtitle,
    queryThread,
    customerId,
  };
};
